import { Show, children, type JSX } from "solid-js";
import { cn } from "./utils/cn";

/**
 * EmptyState — "there is nothing here", said usefully. Always give the operator
 * the next action if one exists.
 */
export function EmptyState(props: {
  title: string;
  body?: string;
  icon?: JSX.Element;
  action?: JSX.Element;
  class?: string;
}): JSX.Element {
  const icon = children(() => props.icon);
  const action = children(() => props.action);

  return (
    <div
      class={cn(
        "flex min-h-[14rem] flex-col items-center justify-center gap-100 px-300 py-500 text-center",
        props.class,
      )}
    >
      <Show when={icon()}>
        <div class="mb-050 text-[color:var(--c9-icon-subtle)]">{icon()}</div>
      </Show>
      <p class="text-h-s font-[670] text-[color:var(--c9-text)]">{props.title}</p>
      <Show when={props.body}>
        <p class="max-w-[48ch] text-body text-[color:var(--c9-text-subtle)]">{props.body}</p>
      </Show>
      <Show when={action()}>
        <div class="mt-200">{action()}</div>
      </Show>
    </div>
  );
}
